import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "milestone-plan-state" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.cellStyles),
      class: "milestone-plan-state__cell"
    }, null, 4),
    _createElementVNode("h3", {
      style: _normalizeStyle(_ctx.textStyles),
      class: "milestone-plan-state__title"
    }, _toDisplayString(_ctx.stateCopy), 5)
  ]))
}